import { ChangeAward } from './ChangeAward';

export class ChangeAwardAlt extends ChangeAward {
  type: string = 'Award.ChangeAltText';
}
